var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { margin: "0 auto" },
      style: _vm.$q.platform.is.mobile ? "width: 90vw;" : "width: 60vw;"
    },
    [
      _c("vue-plyr", { ref: "plyr" }, [
        _c("video", {
          ref: "player",
          attrs: {
            autoplay: "",
            muted: "",
            playsinline: "",
            "webkit-playsinline": "",
            id: "player"
          },
          domProps: { muted: true }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }